// extracted by mini-css-extract-plugin
export default {"table":"styles_table__ZBRgA","invoiceFooter":"styles_invoiceFooter__lEUXO"};